import { feachData, type IQueryParameters } from '~/utils/feach'

const api = {
  get: async (path: string, parameters: IQueryParameters) => {
    return feachData(`${process.env.cmsBaseUrl}/api${path}`, {
      params: parameters,
      headers: {
        Authorization: `Bearer ${process.env.cmsFrontendToken}`,
      },
    })
  },
  post: async (path: string, body: unknown) => {
    return feachData(
      `${process.env.cmsBaseUrl}/api${path}`,
      {
        body,
        headers: {
          Authorization: `Bearer ${process.env.cmsFrontendToken}`,
        },
      },
      'POST'
    )
  },
}

export default api
